import { useState } from 'react';
import PropTypes from 'prop-types';
import ChatBubbleOutlineIcon from '@material-ui/icons/ChatBubbleOutline';
import { useTranslation } from 'react-i18next';
import SendMessageModal from './SendMessageModal';
import CustomButton from './CustomButton';
import useGetVehicle from '../hooks/useGetVehicle';

const SendMessageButton = ({ className }) => {
  const { t } = useTranslation('details');
  const [visible, setVisible] = useState(false);
  const { vehicle } = useGetVehicle();

  const { directMessageEnabled } = vehicle.seller;
  if (!directMessageEnabled) return null;

  const toggleModal = () => setVisible(!visible);

  return (
    <>
      <CustomButton
        id="askButton"
        variant="contained"
        color="askButton"
        className={className}
        size="large"
        onClick={toggleModal}
        startIcon={<ChatBubbleOutlineIcon />}
      >
        {t('Ask')}
      </CustomButton>
      <SendMessageModal visible={visible} onClose={toggleModal} />
    </>
  );
};

SendMessageButton.propTypes = {
  className: PropTypes.string,
};

SendMessageButton.defaultProps = {
  className: '',
};

export default SendMessageButton;
